import React from 'react';

import { ITotalsProps } from '../types';

import Totals from './totals';

const TotalsContainer: React.FC<ITotalsProps> = props => <Totals {...props} />;

export default TotalsContainer;
